export default __webpack_public_path__ + "static/media/Dina_Icon.3c2f75eb.png";